import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { updateLightningGroupAPI } from './api';

const LIGHTNING_GROUPS = 'lightningGroups';
const LIGHTNING_SCENARIOS = 'lightningScenarios';

export function useUpdateLightningGroup({ onSuccess }) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL().toLowerCase();

  const { openModal } = useModal();

  const { mutate, isLoading, isSuccess, isError } = useMutation(
    (data) => updateLightningGroupAPI(data),
    {
      onSuccess: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'updateGroupSuccess',
          },
        });
        queryClient.invalidateQueries([LIGHTNING_GROUPS, tenantId]);
        queryClient.invalidateQueries([LIGHTNING_SCENARIOS, tenantId]);
        onSuccess();
      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'updateGroupFail',
          },
        });
      },
    },
  );

  return {
    updateLightningGroup: mutate,
    isLoading,
    isSuccess,
    isError,
  };
}
